<template>
  <v-container
    style="zoom: 0.85"
    fluid
    class="rbu-section-fluctuation"
    v-if="section"
  >
    <div class="fixed-rbu-section-header">
      <v-row class="">
        <v-btn
          text
          color="primary"
          exact
          :to="{
            name: 'rbu-volume-detail',
            params: {
              editionId: section.edition.id,
              volumeId: section.volume.id,
            },
          }"
        >
          <h3 class="font-weight-regular">
            &lt;&lt; {{ section.volume.name }}
          </h3>
        </v-btn>
      </v-row>
      <v-row class="rbu-section-info-wrapper" style="height: 60px">
        <div style="display: flex; justify-content: space-between; width: 90%">
          <h3>
            {{ section.edition.edition }} - {{ section.name }} Fluctuation
          </h3>
          <div>
            <v-btn color="primary" @click="save"
              >{{ isChanged || isChangedSection ? "*" : "" }} Save
            </v-btn>
            <v-btn
              color="primary"
              class="ml-4"
              @click="downloadSectionFluctuationPdf"
            >
              Export PDF
            </v-btn>
          </div>
        </div>
      </v-row>
    </div>

    <RbuSectionFluctuationEditor
      style="margin-top: 70px"
      :section="section"
      v-model="fluctuationModules"
    ></RbuSectionFluctuationEditor>

    <RbuSectionFluctuationContractPercentage
      :section="section"
      :fluctuation-modules="fluctuationModules"
      @update="onContractPercentageUpdate"
    ></RbuSectionFluctuationContractPercentage>
  </v-container>
</template>
<script>
import { computed, onMounted, provide, ref, watch } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import RbuSectionFluctuationEditor from "@/components/rbu/RbuSectionFluctuationEditor.vue";
import RbuSectionFluctuationContractPercentage from "@/components/rbu/RbuSectionFluctuationContractPercentage.vue";

export default {
  name: "RbuSectionFluctuation",
  components: {
    RbuSectionFluctuationContractPercentage,
    RbuSectionFluctuationEditor,
  },
  beforeRouteLeave(to, from, next) {
    if (this.isChanged || this.isChangedSection) {
      const answer = window.confirm(
        "There is unsaved changes, are you sure to leave?"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  setup(props, { root }) {
    const section = ref(null);
    provide("RBU_SECTION", () => section.value);
    provide(
      "RBU_EDITION_DATASET",
      computed(() => {
        return section.value ? section.value.edition.selected_dataset : null;
      })
    );

    provide(
      "RBU_EDITION_LATEST",
      computed(() => {
        return section.value ? section.value.edition.latest : null;
      })
    );
    provide(
      "RBU_EDITION_BASE_START",
      computed(() => {
        return section.value ? section.value.edition.base_start : null;
      })
    );
    provide(
      "RBU_EDITION_BASE_END",
      computed(() => {
        return section.value ? section.value.edition.base_end : null;
      })
    );

    let cloneItem = null;
    let cloneSection = null;
    const isChanged = ref(false);
    const isChangedSection = ref(false);
    const getSection = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/",
        params: { section_id: root.$route.params.sectionId },
      });

      if (response.body.success) {
        section.value = response.body.section;
        if (!section.value.adjustment_percentage_formula) {
          section.value.adjustment_percentage = 100;
        }
        cloneSection = JSON.parse(JSON.stringify(section.value));
        isChangedSection.value = false; // Reset
        console.debug("fluctuation_value: ", section.value.fluctuation_value);
      }
    };
    const onContractPercentageUpdate = function (updates) {
      console.debug("onContractPercentageUpdate", updates);
      section.value = {
        ...section.value,
        ...updates,
      };
    };

    const fluctuationModules = ref([]);
    const getFluctuationModules = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/fluctuation_module/",
        params: { section_id: root.$route.params.sectionId },
      });

      if (response.body.success) {
        fluctuationModules.value = response.body.modules;

        cloneItem = JSON.parse(JSON.stringify(fluctuationModules.value));
        isChanged.value = false; // Reset
      }
    };

    function numberToAlphabet(num) {
      let result = "";
      while (num >= 0) {
        let remainder = num % 26;
        result = String.fromCharCode(65 + remainder) + result;
        num = Math.floor(num / 26) - 1;
      }
      return result;
    }

    const save = async function () {
      console.debug("save", fluctuationModules.value);

      async function processFluctuation(fluctuation) {
        const file = fluctuation.file
          ? fluctuation.file instanceof File
            ? await root.$convertFileToBase64(fluctuation.file)
            : fluctuation.file.id
          : null;
        const filename = fluctuation.file
          ? fluctuation.file instanceof File
            ? fluctuation.file.name
            : null
          : null;

        const adjustment_percentage =
          fluctuation.adjustment_percentage || "100";
        const adjustment_value = fluctuation.adjustment_value || "0";
        const adjustment_percentage_formula =
          fluctuation.adjustment_percentage_formula || "";
        const adjustment_value_formula =
          fluctuation.adjustment_value_formula || "";

        return {
          ...fluctuation,
          previous_dataset: fluctuation.previous_datapoint
            ? fluctuation.previous_datapoint.dataset.id
            : null,
          previous_datapoint: fluctuation.previous_datapoint
            ? fluctuation.previous_datapoint.id
            : null,
          current_dataset: fluctuation.current_datapoint
            ? fluctuation.current_datapoint.dataset.id
            : null,
          current_datapoint: fluctuation.current_datapoint
            ? fluctuation.current_datapoint.id
            : null,
          file,
          filename,
          adjustment_percentage,
          adjustment_value,
          adjustment_percentage_formula,
          adjustment_value_formula,
        };
      }

      async function processModule(module) {
        const fluctuations = await Promise.all(
          module.fluctuations.map(processFluctuation)
        );

        module.adjustment_percentage = module.adjustment_percentage || "100";
        module.adjustment_percentage_formula =
          module.adjustment_percentage_formula || "";
        module.adjustment_value = module.adjustment_value || "0";
        module.adjustment_value_formula = module.adjustment_value_formula || "";

        return {
          ...module,
          fluctuations,
        };
      }

      const fluctuation_modules = await Promise.all(
        fluctuationModules.value.map(processModule)
      );

      if (
        section.value.fluctuation_value &&
        section.value.fluctuation_value >= 1000
      ) {
        alert(
          "Final Adjusted trade % is more than 1000%, please edit and try again."
        );
        return;
      }

      let miss_census_rate = false;
      let miss_census_rate_error_msg = "";

      for (const module of fluctuation_modules) {
        for (const f of module.fluctuations) {
          if (!f.current_datapoint || !f.previous_datapoint) {
            miss_census_rate = true;
            miss_census_rate_error_msg += `Please complete the fluctuation census rate in Module ${numberToAlphabet(
              module.order_no
            )} \n`;
          }
        }
      }

      if (miss_census_rate) {
        alert(miss_census_rate_error_msg);
        return;
      }

      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/fluctuation_module/set/",
        params: {
          section_id: root.$route.params.sectionId,
          adjustment_value_first: section.value.adjustment_value_first,
          adjustment_value: section.value.adjustment_value || 0,
          adjustment_value_formula:
            section.value.adjustment_value_formula || "",
          adjustment_value_descriptions:
            section.value.adjustment_value_descriptions || "",

          adjustment_percentage: section.value.adjustment_percentage || 100,
          adjustment_percentage_formula:
            section.value.adjustment_percentage_formula || "",
          adjustment_percentage_descriptions:
            section.value.adjustment_percentage_descriptions || "",
          fluctuation_value: section.value.fluctuation_value || 0,

          fluctuation_modules,
        },
      });

      if (response.body.success) {
        getSection();
        getFluctuationModules();
      }
    };

    const downloadSectionFluctuationPdf = async function () {
      let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/generate_fluctuation_pdf/",
        params: {
          section_id: section.value.id,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURI(response.headers.get("content-filename"));
      link.click();
    };

    function getDifferences(obj1, obj2, path = "") {
      if (path === ".beforeAdjustments") return;
      if (typeof obj1 !== "object" || obj1 === null) {
        if (obj1 != obj2) {
          console.debug(`Difference at ${path}:`, {
            original: obj1,
            current: obj2,
          });
          isChanged.value = true;
        }
      } else if (obj1 !== null && obj2 !== null) {
        Object.keys(obj1).forEach((key) => {
          if (key !== "beforeAdjustments" && !obj2.hasOwnProperty(key)) {
            console.debug(`Key '${key}' missing in obj2 at ${path}`);
            isChanged.value = true;
          } else {
            getDifferences(obj1[key], obj2[key], `${path}.${key}`);
          }
        });

        Object.keys(obj2).forEach((key) => {
          if (key !== "beforeAdjustments" && !obj1.hasOwnProperty(key)) {
            isChanged.value = true;
            console.debug(`Key '${key}' missing in obj1 at ${path}`);
          }
        });
      }
    }

    onMounted(() => {
      getSection();
      getFluctuationModules();
    });

    watch(
      fluctuationModules,
      (newValue) => {
        isChanged.value = false;
        getDifferences(cloneItem, newValue);
      },
      { deep: true }
    );

    watch(
      section,
      (newValue) => {
        isChangedSection.value = false;
        getDifferences(cloneSection, newValue);
      },
      { deep: true }
    );

    return {
      section,
      onContractPercentageUpdate,
      fluctuationModules,
      save,
      isChanged,
      isChangedSection,
      downloadSectionFluctuationPdf,
    };
  },
};
</script>

<style lang="less">
.rbu-section-fluctuation {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .fixed-rbu-section-header {
    position: fixed;
    top: 5rem;
    padding-top: 1rem;
    width: 100%;
    background-color: #efeeee;
    z-index: 10; /* Adjust as needed */
  }

  .rbu-section-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .rbu-section-info {
      flex: 1 1 0;
    }
  }

  .rbu-card {
    background-color: white;
    padding: 12px;
    display: flex;
    flex-direction: column;

    .rbu-card-header {
      display: flex;

      .ignore-checkbox {
        i,
        label {
          color: var(--v-primary-base);
        }
      }
    }

    .rbu-card-content {
      display: flex;
      flex-direction: column;
      padding: 8px 0;

      thead {
        background: rgba(0, 0, 0, 0.06);
      }

      .rbu-table-section-header {
        vertical-align: baseline;
        height: 100%;
        color: rgba(0, 0, 0, 0.4);
        padding-left: 0 !important;
      }
    }
  }

  .rbu-section-fluctuation-column-1 {
    width: 100px;
  }

  .rbu-section-fluctuation-column-2 {
    width: 500px;
  }

  .rbu-section-fluctuation-column-value {
    width: 100px;
  }

  .rbu-section-fluctuation-column-multiplier {
    width: 100px;
  }

  .rbu-section-fluctuation-column-formula {
    width: 300px;
  }

  .rbu-section-fluctuation-column-descriptions {
    width: 300px;
  }

  .rbu-section-fluctuation-column-actions {
    width: 100px;
  }

  .rbu-section-fluctuation-card {
    background-color: white;
    padding: 12px;
    display: flex;
    flex-direction: column;

    .rbu-section-fluctuation-card-header {
      display: flex;

      .ignore-checkbox {
        i,
        label {
          color: var(--v-primary-base);
        }
      }
    }
  }
}
</style>
